import type { CSSProperties } from "react";

export type ExportTextButtonProps = {
  /** Visible label; default `Export`. */
  label?: string;
  className?: string;
  /** Classes for the underlined label (e.g. `text-[12px]`). */
  labelClassName?: string;
  /** Override for `aria-label` (defaults from `label`). */
  "aria-label"?: string;
  style?: CSSProperties;
  type?: "button" | "submit";
};

/**
 * Text-style export control: download glyph + underlined label only (no border).
 * Matches Brand-funded Promotions export treatment in Figma.
 */
export const ExportTextButton = ({
  label = "Export",
  className = "",
  labelClassName = "",
  "aria-label": ariaLabel,
  style,
  type = "button",
}: ExportTextButtonProps) => (
  <button
    type={type}
    style={style}
    className={`inline-flex items-center gap-2 bg-transparent p-0 font-normal text-[#333] hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#333]/25 ${className}`.trim()}
    aria-label={ariaLabel ?? label}
  >
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      className="shrink-0 text-current"
    >
      <path
        d="M3 12.5V13a1.5 1.5 0 001.5 1.5h7A1.5 1.5 0 0013 13v-.5M4.5 6.5L8 10l3.5-3.5M8 10V2"
        stroke="currentColor"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span
      className={`text-[14px] leading-5 underline decoration-[#333] decoration-solid underline-offset-[3px] ${labelClassName}`.trim()}
    >
      {label}
    </span>
  </button>
);

export default ExportTextButton;
